import {emptyGuid} from "../../../../Utilities/commonUtilities";

export const aphCatalogItemModel = ({
                                        catalogNumber,
                                        cost,
                                        id = emptyGuid,
                                        title,
                                        availabilityStatus,
                                        whatsNewStartDate,
                                        whatsNewEndDate,
                                    }: Record<string, any> = {}) => ({
    catalogNumber,
    cost,
    id,
    title,
    availabilityStatus,
    whatsNewStartDate,
    whatsNewEndDate,
});


export const emptyAphCatalogItemModel = aphCatalogItemModel();
